import {
  geoLacationDel3x,
  pin3x,
  cafePlacemark,
  shopPlacemark,
  shopSoonPlacemark,
  cafeSoonPlacemark
} from '@images';
import preparePoint from '@utils/preparePoint';
import type { PlacemarkI } from '@components/MapRender';

interface PinPlacemarkStore {
  point?: string | null;
}

/**
 * Builds the standard red/grey location-pin placemark used by the pickup-point
 * maps (PickupSelector, PickupBrowseModal, Store page). Active stores get the
 * large red pin; the rest get the small grey pin.
 */
export const buildPickupPinPlacemark = (
  store: PinPlacemarkStore,
  isActive: boolean,
  onClick: () => void
): PlacemarkI => ({
  geometry: preparePoint(store.point ?? ''),
  onClick,
  options: {
    iconLayout: 'default#image',
    iconImageSize: isActive ? [40, 58] : [18, 24],
    iconImageOffset: isActive ? [-20, -58] : [-9, -24],
    iconImageHref: isActive ? geoLacationDel3x : pin3x
  }
});

/**
 * Shared cafe/shop/"soon" placemark icon options.
 *
 * `isCafe` is decided by the caller — call sites disagree on which store type
 * maps to the cafe icon (`'cafe'` vs `ShopType.OysterBar`), so that rule is
 * intentionally left at the call site to preserve behavior.
 */
export const buildShopTypePlacemarkOptions = (
  isCafe: boolean,
  opensSoon: boolean,
  withContent = false
): PlacemarkI['options'] => ({
  iconLayout: withContent ? 'default#imageWithContent' : 'default#image',
  iconImageSize: [40, 58],
  iconImageOffset: [-20, -58],
  iconImageHref: isCafe
    ? opensSoon
      ? cafeSoonPlacemark
      : cafePlacemark
    : opensSoon
    ? shopSoonPlacemark
    : shopPlacemark
});
